import { render } from "./MyMenuButton.vue?vue&type=template&id=1bf8db22&scoped=true"
import script from "./MyMenuButton.vue?vue&type=script&lang=js"
export * from "./MyMenuButton.vue?vue&type=script&lang=js"

import "./MyMenuButton.vue?vue&type=style&index=0&id=1bf8db22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf8db22"]])

export default __exports__